import { createContext } from 'react';

export interface RTLContextType {
  direction: 'ltr' | 'rtl';
  toggleDirection: () => void;
  setDirection: (direction: 'ltr' | 'rtl') => void;
}

export const RTLContext = createContext<RTLContextType | undefined>(undefined);
